var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"pay-range-version-bar",class:[
    `pay-range-version-bar--${_setup.normalizedState}`,
    { 'pay-range-version-bar--selected': _vm.selected },
  ],attrs:{"role":"img","aria-label":_setup.accessibleLabel,"title":_setup.label},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('span',{staticClass:"pay-range-version-bar__label"},[_vm._v(_vm._s(_setup.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }